<script>
import userService from "@/services/modules/userService";

export default {
  name: "index",
  data() {
    return {
      pages: null
    };
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    copyText() {
      this.$toast.success(this.$t("operationsPage.copy"));
    },
    getPageData() {
      userService.getApiDocPages().then(res => {
        this.pages = res.data.data.page_content;
      });
    }
  }
};
</script>

<template>
  <v-col cols="12" md="6" class="ma-auto">
    <v-card color="gray7">
      <v-container fluid class="dashboard-page py-0">
        <v-row class="py-2 pa-2">
          <v-col cols="12" class="text-end ltr">
            <a
              :href="
                `https://api-web.excoino.com/assets/file/${$cookies.get(
                  'lang'
                )}ApiDoc.pdf`
              "
              target="_blank"
            >
              <v-btn color="primary" class="text--white rounded-lg ">{{
                $t("apiManagement.documentation")
              }}</v-btn>
            </a>
          </v-col>
          <v-col class="warningTransparent mb-6 rounded-lg" cols="12">
            <v-row>
              <v-col class="py-0" cols="auto">
                <v-icon size="22" clr="var(--v-warning-base)"
                  >$warningWallet</v-icon
                >
              </v-col>
              <v-col class="py-0">
                <div v-html="pages" class="font-Regular-12 warning--text"></div>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <div class="text-end mb-2 rtl">Access Token</div>
            <v-card
              style="direction: ltr"
              class="py-4 px-3 d-flex align-center justify-space-between"
              color="gray9"
              outlined
              elevation="0"
            >
              <div class="gray2--text text-truncate">
                {{ $cookies.get("accessToken").substr(0, 70) }} ...
              </div>
              <v-btn
                icon
                small
                v-clipboard:copy="$cookies.get('accessToken')"
                v-clipboard:success="copyText"
              >
                <v-icon
                  clr="var(--v-gray1-base)"
                  v-html="'$copy'"
                  size="20"
                ></v-icon>
              </v-btn>
            </v-card>
          </v-col>

          <v-col cols="12">
            <div class="text-end mb-2 rtl">Refresh Token</div>
            <v-card
              style="direction: ltr"
              class="py-4 px-3 d-flex align-center justify-space-between"
              color="gray9"
              outlined
              elevation="0"
            >
              <div class="gray2--text text-truncate">
                {{ $cookies.get("refreshToken").substr(0, 70) }} ...
              </div>
              <v-btn icon small v-clipboard:copy="$cookies.get('refreshToken')">
                <v-icon
                  clr="var(--v-gray1-base)"
                  v-html="'$copy'"
                  size="20"
                ></v-icon>
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-col>
</template>

<style scoped lang="scss"></style>
